module.exports = __webpack_public_path__ + "img/petstairs07.3b9bc1c8.jpg";